import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth/auth.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Logging } from '../logging';
import { ApiService } from '../shared/api-service/api.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


declare var jquery:any;
declare var $ :any;
declare var App:any;

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {

  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router) {


}

loading: Boolean = false;
hasError: Boolean = false;
errorMessage: string ;
successMessage :string = "";
showForceLogoutError:any = false;
passwordReset: Boolean = false;

  ngOnInit() { 
    if(!this.auth.loginDetailsSet()){
      this.router.navigate(['/login']);
    }

  }

  resetPassword(form: NgForm)
  {
    
    var self = this;

    //Set loading to true to show loader
    this.loading = true;
    this.hasError = false;

    // Collect form values
    const values = form.value;

    const body = {
      email: values.emailorphone,
    };

    //Make the api request
    this.api.post('/users/resetpassword', body)
      .subscribe(
        res_data => {
        Logging.log(res_data);

        var animationOut = "animated fadeOutLeft";
        var animationend = "wenkitAnimationEnd mozAnimationEnd MS AnimationEnd oanimationend animationend";
        
        //Hide the input box and show the success message
        $('#emailorphone').addClass(animationOut);
        $('#reset_btn').addClass(animationOut);
        $('#login_btn').show();
         
          this.loading = false;
          this.passwordReset = true;
          this.successMessage = "A new password has been sent to you via your registered channels";
          
        }, error_message => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
          this.passwordReset = false;
        }
      );
  }


  clearErrors(){
    this.hasError = false;
    this.passwordReset  = false;
    this.successMessage = "";

  }

  

}





// WEBPACK FOOTER //
// ./src/app/resetpassword/resetpassword.component.ts